import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@sandtech-hub-monorepo/ui-kit';
import { formatGPA, TranscriptSummary } from '../utils';

interface Props {
  summary: TranscriptSummary;
  /** Credits earned via transfer / prior credit. GPA-neutral, earned only. */
  transferEarnedCredits?: number;
}

const CumulativeTable = ({ summary, transferEarnedCredits = 0 }: Props) => (
  <div className="w-full print:break-inside-avoid">
    <div className="flex items-center px-3 py-1.5 bg-muted/30">
      <p className="font-semibold text-sm text-foreground">Cumulative</p>
    </div>

    <Table>
      <TableHeader>
        <TableRow className="border-muted">
          <TableHead className="w-full font-normal sm:text-xs">Name</TableHead>
          <TableHead className="text-center whitespace-nowrap leading-tight font-normal sm:text-xs">
            Credits
            <br />
            Attempted
          </TableHead>
          <TableHead className="text-center whitespace-nowrap leading-tight font-normal sm:text-xs">
            Credits
            <br />
            Earned
          </TableHead>
          <TableHead className="text-center whitespace-nowrap font-normal sm:text-xs">
            Points
          </TableHead>
          <TableHead className="text-center whitespace-nowrap font-normal sm:text-xs">
            GPA
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow className="border-muted">
          <TableCell className="text-foreground">Resident</TableCell>
          <TableCell className="text-center text-foreground">
            {summary.totalAttemptedCredits}
          </TableCell>
          <TableCell className="text-center text-foreground">
            {summary.totalEarnedCredits}
          </TableCell>
          <TableCell className="text-center text-foreground">
            {summary.totalGradePoints.toFixed(2)}
          </TableCell>
          <TableCell className="text-center text-foreground">
            {formatGPA(summary.cumulativeGPA)}
          </TableCell>
        </TableRow>
        <TableRow className="border-muted">
          <TableCell className="text-foreground">Transfer</TableCell>
          <TableCell className="text-center text-muted-foreground">—</TableCell>
          <TableCell className="text-center text-foreground">
            {transferEarnedCredits}
          </TableCell>
          <TableCell className="text-center text-muted-foreground">—</TableCell>
          <TableCell className="text-center text-muted-foreground">—</TableCell>
        </TableRow>
        <TableRow className="border-muted">
          <TableCell className="font-semibold text-foreground">
            Overall
          </TableCell>
          <TableCell className="text-center font-medium text-foreground">
            {summary.totalAttemptedCredits}
          </TableCell>
          <TableCell className="text-center font-medium text-foreground">
            {summary.totalEarnedCredits + transferEarnedCredits}
          </TableCell>
          <TableCell className="text-center font-medium text-foreground">
            {summary.totalGradePoints.toFixed(2)}
          </TableCell>
          <TableCell className="text-center font-medium text-foreground">
            {formatGPA(summary.cumulativeGPA)}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </div>
);

export default CumulativeTable;
